import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./LogoutButton.css";

const LogoutButton = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return null;
  }

  const handlePortalClick = () => {
    navigate("/portal");
  };

  const handleStudentsClick = () => {
    navigate("/portal/students");
  };

  const handleLogout = () => {
    logout();
    navigate("/portal/login");
  };

  return (
    <div className="logout-container">
      {/* {user?.picture && (
        <img src={user.picture} alt={user.name} className="logout-avatar" />
      )} */}
      <button onClick={handlePortalClick} className="header-artists">
        Admin Portal
      </button>
      <button onClick={handleStudentsClick} className="header-artists">
        Manage Students
      </button>
      <div className="logout-user-info">
        <div className="logout-user-name">{user?.name}</div>
        <div className="logout-user-email">{user?.email}</div>
      </div>
      <button onClick={handleLogout} className="logout-button">
        Logout
      </button>
    </div>
  );
};

export default LogoutButton;
